"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (arr) {
    return arr && (arr.length === 0 ? undefined : arr[arr.length - 1]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/array/getLast.js
// module id = 576
// module chunks = 0